import api from '@/shared/api/base-api';
import {
  CategoriesResponse,
  GetCategoriesParams,
  ICategory,
  ICategoryWithProductsResponse,
  IProductCategoriesParams,
} from '../model/types';

export const categoryApi = {
  getAll: async (params: GetCategoriesParams): Promise<CategoriesResponse> => {
    const { data } = await api.get('/v2/shipper-categories', { params });
    return data;
  },

  getCategoryProducts: async (params: IProductCategoriesParams) => {
    const res = await api.get<ICategoryWithProductsResponse>(
      '/v2/aggregator/category-with-products',
      {
        params,
      }
    );
    return res.data;
  },
};

export function getCategoryList(
  params: Record<string, any>,
  shipper_id?: string,
  platform_id?: string
) {
  return api.get<{
    categories: ICategory[];
    count: string;
  }>(`/v2/category`, {
    params,
    headers: {
      Shipper: shipper_id,
      Platform: platform_id,
    },
  });
}
